<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box" v-if="result_analysis != ''">
          <!-- excel btn code -->
          <v-row dense>
              <v-col cols="12" sm="6" md="6">
                  <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'ResultAnalysisReport')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
              </v-col>
          </v-row>
          <v-row>
              <v-col cols="12" sm="12" md="12">
                  <div id="my-table-id">
                      <v-simple-table dense class="elevation-1" fixed-header height="500px">
                          <thead>
                              <tr>
                                  <td :colspan="result_analysis_values.length + 3">
                                      <strong>{{ org_basic_data.school_name }}</strong>
                                  </td>
                              </tr>
                              <tr>
                                  <td :colspan="result_analysis_values.length + 3">
                                      <strong>{{ semester }} Result Analysis</strong>
                                  </td>
                              </tr>
                              <tr>
                                  <td :colspan="result_analysis_values.length + 3">
                                      <strong>{{ section_new }} Section</strong>
                                  </td>
                              </tr>
                              <tr>
                                  <td class="">Sr. No.</td>
                                  <td class="">Class & Division</td>
                                  <td class="">Strength</td>
                                  <td class="" v-for="(header, index) in result_analysis_values" :key="index">
                                      {{ header }}
                                  </td>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(l, index) in result_analysis" :key="index">
                                  <td>{{ index + 1 }}</td>
                                  <td>{{ l.standard }} {{ l.division }}</td>
                                  <td>{{ l.strength }}</td>
                                  <td v-for="(header, index) in l.overall_count" :key="index">
                                      {{ header }}
                                  </td>
                              </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </v-col>
              <!-- <v-col cols="6" sm="6" md="6">
                   <center><chart  :options="option"></chart></center>
               </v-col> -->
          </v-row>
      </v-card>
      <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      components: {},
      data() {
          return {
              snackbar_msg: "",
              color: "",
              snackbar: false,
              overlay: false,
              search: null,
              sel_ay_data: null,
              section: null,
              sem: null,
              result_analysis_values: [],
              result_analysis: [],
              semester: null,
              org_basic_data: null,
              section_new: null,
              assessment_type: null,
              //  option: {
              //     height: "200px",
              //     color: ["#3398DB"],
              //      tooltip: {
              //         trigger: "axis",
              //         axisPointer: {
              //             type: "shadow",
              //             label: {
              //                 show: true,
              //             },
              //         },
              //     },
              //    toolbox: {
              //         show: true,
              //         feature: {
              //             mark: { show: true },
              //             magicType: { show: true, type: ["line", "bar","stack"] , title:{line:"Switch to Line Chart",bar:"Switch to Bar Chart",stack:"Switch to Stack Chart"}},
              //             restore: { show: true, title: 'Restore'  },
              //             saveAsImage: {
              //                 show: true,
              //                 title: 'Save As Image'
              //             },
              //             dataView: {
              //                 show: true,
              //                 title: 'Data View',
              //                 readonly:false
              //             },
              //         },
              //     },
              //     calculable: true,
              //     legend: {
              //         data: [],
              //         itemGap: 5,
              //     },
              //     grid: {
              //         top: "12%",
              //         left: "6%", // change from 1% by shiv
              //         right: "16%", // change from 10% by shiv
              //         bottom:" 3%",
              //         containLabel: true,
              //     },
              //     xAxis: {
              //         type: "category",
              //         data: [],
              //         axisLabel: {
              //             margin: 15,
              //             rotate: 45,
              //         },
              //         name: "Class",
              //         nameLocation: "end",
              //         offset: 10,
              //     },
              //     yAxis: {
              //         type: "value",
              //         name: "Count",
              //         nameLocation: "end",
              //         offset: 10,
              //     },
              //     legend: {
              //         data: ["X-axis:Organization", "Y-axis:# Students"],
              //         show: true,
              //     },
              //     series: [
              //         {
              //             data: [],
              //             value: [],
              //             type: "bar",

              //             //name:'Direct'
              //         },
              //     ],
              //     // series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
              // },
          };
      },
      watch: {
          overlay(val) {
              val = () => {
                  this.overlay = false;
              };
          },
      },
      methods: {
          fnExcelReport(id, name) {
              var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
              tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
              tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
              tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
              tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
              tab_text = tab_text + "<table border='1px'>";
              var exportTable = $("#" + id).clone();
              exportTable.find("input").each(function (index, elem) {
                  $(elem).remove();
              });
              tab_text = tab_text + exportTable.html();
              tab_text = tab_text + "</table></body></html>";
              var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

              //Save the file
              // var blob = new Blob([tab_text], {
              //   type: "application/vnd.ms-excel;charset=utf-8",
              // });
              // window.saveAs(blob, fileName);
              const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              const filename = name + ".xls";

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  // For IE
                  window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                  // For modern browsers
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
              }
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          main() {
              const formData = {
                  ay: this.sel_ay_data,
                  section: this.section,
                  sem: this.sem,
                  assessment_type: this.assessment_type
              };
              this.overlay = true;
              axios
                  .post("/Examination/resultAnalysis", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.result_analysis = res.data.result_analysis;
                          this.result_analysis_values = res.data.result_analysis_values;
                          this.semester = res.data.semester;
                          this.section_new = res.data.section;
                          this.org_basic_data = res.data.org_basic_data;
                          // this.option.series[0].data = res.data.value;
                          //     this.option.xAxis.data = res.data.data;
                          //     this.option.series[0].label = {
                          //         normal: {
                          //             show: true,
                          //             position: "top",
                          //             formatter: (params) => {
                          //                 let outof = this.option.series[0].value[params.dataIndex]; //this.series[0].data[params.dataIndex];;
                          //                 return outof;
                          //             },
                          //         },
                          //     };
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.overlay = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
      },
      mounted() {
          this.sel_ay_data = localStorage.getItem("setay");
          this.section = localStorage.getItem("setsection");
          this.sem = localStorage.getItem("setsem");
          this.assessment_type = localStorage.getItem("setassessmenttype");
          // this.org = localStorage.getItem("setorg");
          this.main();
      },
  };
</script>
<style scoped>
  .text-color {
      font-weight: bold;
      color: red;
  }
  tr,
  td,
  th {
      border: 1px solid #ccc;
      text-align: center;
  }
  tr,
  tbody {
      border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
  }
  td {
      margin: 0.3rem !important;
      padding: 0.4rem !important;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
      }
      td + td,
      th + th {
          width: auto;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
  }
  .mytable /deep/ thead th {
      background: #0f2027 !important; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
</style>
